import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';

export const useGoods = (id: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log("useGoodscontext---------", context.useApiError);

  // Shared ref holding the response from the API
  const result = sharedRef(null, `useGoods-${id}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useGoods-loading-${id}`);

  // Shared ref holding errors from the methods
  const error = sharedRef({}, `useGoods-error-${id}`);

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const load = async (goodId: number) => {
    try {
      loading.value = true;
      const res = await context.$xbuy.api.goodInfo(goodId);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        result.value = res.data;
        error.value.load = null;
      } else {
        error.value.load = new Error(res.message);
      }
    } catch (err) {
      error.value.load = err;
    } finally {
      loading.value = false;
    }
  };

  return {
    load,
    goods: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
